"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.testConnection = function () { return ({
    type: types_1.InternalClientActionType.TEST_CONNECTION
}); };
exports.testConnectionComplete = function (success) { return ({
    type: types_1.InternalClientActionType.TEST_CONNECTION_COMPLETE,
    success: success
}); };
//# sourceMappingURL=client.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/actions/internal/client.js
 ** module id = 2071
 ** module chunks = 0
 **/